<template>
  <div>
    <sessions-session
        v-if="session"
        :session="session"
        :profile="profile"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SessionsSession from "@/components/common/sessionComponents/sessions/sessionGoogle";
import RecordViews from "@/mixins/RecordViews";

export default {
  name: "Sessions_Sesssion",
  mixins: [RecordViews],
  components: {
    SessionsSession
  },
  created() {
    //this.getProfile();
  },
  beforeMount() {
    this.sessionSlug = this.$route.params.sessionSlug;
    this.resourcePath = this.$route.params.resource;
    this.resourceItemPath = this.$route.params.resourceItem;

    if (this.resourcePath) {
      console.log(
          `Title: ${this.sessionSlug} | Resource: ${this.resourcePath} | ResourceItem: ${this.resourceItemPath} `
      );
    }
  },
  mounted() {
    this.getSessionData();
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile"
    }),
    session() {
      return this.sessionData && this.sessionData.doc ?
          this.sessionData.doc : null;
    },
    registrationInfo(){
      return this.sessionData;
    }
  },
  methods: {
    getProfile() {
      this.$store
          .dispatch("user/getProfile")
          .then(() => {
            this.$nprogress.done();
          })
          .catch(error => {
            debugger;
            this.$store.dispatch("user/showNotification", {
              title: error.code,
              description: error.message,
              variant: "danger"
            });
          });
    },
    handleNoSessionData() {
      this.$router.push("/");
    },
    getSessionData() {
      if (this.sessionSlug) {
        this.$store
            .dispatch("listings/getSessionBySlug", {slug: this.sessionSlug})
            .then(res => {
              if (Object.keys(res).length === 0) {
                //this.handleNoSessionData();
              } else {
                this.sessionData = res;
                this.recordView(this.sessionData.id);
              }
            })
            .catch(e => {
              console.log(e);
            });
      }
    },
    recordView(sessionId) {
      this.$store.dispatch("listings/recordFeedback", {
        userId: this.user ? this.user.uid : null,
        pathId: "sessions",
        entityId: sessionId,
        feedbackType: "views",
        sessionId: this.checkSession("sessions")
      });
    }
  },
  watch: {
    profile(val) {
      return val;
    }
  },
  metaInfo() {
    return {
      title: null,

    };
  },
  data() {
    return {
      resource:{      //@ToDo- comes from publishing
        toolId:'1goNyf7FPZre0yOJU2Vx',
        name: 'Sessions'
      },
      sessionSlug: null,
      sessionData: null,
      sessionTitle: null,
      resourcePath: null,
      resourceItemPath: null,
      collectedCorners: null
    };
  },
};
</script>
